import defaultTheme from 'tailwindcss/defaultTheme';
import {colorVar} from './colors';
import {rounding} from './rounding';
import {shadow} from './shadow';

export const theme = {
    ...defaultTheme,
    colors: {
        inherit: 'inherit',
        current: 'currentColor',
        transparent: 'transparent',
        ...colorVar,
    },
    borderRadius: {
        ...rounding,
        full: '9999px',
        pill: '100%',
    },
    boxShadow: {
        ...shadow,
    },
    supports: {
        dvh: 'height:100dvh',
    },
    screens: {
        'can-hover': {raw: '(any-hover:hover)'},
    },
};
